module.exports = __webpack_public_path__ + "img/img04.53ce339a.png";